import { GrupoContaDreModel } from "./grupo-conta-dre.model";

export class ContaDreModel {
  id?: number;
  descricao?: string;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  grupoContaDre?: GrupoContaDreModel;

  constructor(options: ContaDreModel = {}) {
    this.id = options.id || null;
    this.descricao = options.descricao || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.grupoContaDre = options.grupoContaDre || null;
  }
}